import React from 'react';
import "./DictionaryWindow.css";
import GameWindowHeader from "../GameWindowHeader";

export default class DictionaryWindow extends React.Component {
    constructor() {
        super();

        this.state = {
            currentId: 0,
            dictionary: []
        };
    }

    updateId(id) {
        this.setState({
            currentId: id
        });
    }

    componentDidMount() {
        if (window.dictionary) {
            this.setState({
                dictionary: window.dictionary
            })
        } else {
            fetch("dictionary.json")
                .then(res => res.json())
                .then(res => this.loadDictionary(res.terminology))
                .then(r => {
                    if (this.props.currentPage) {
                        let id = this.getIdByAnchor(this.props.currentPage);
                        this.updateId(id);
                        this.scrollToElement(id);
                    }
                });
        }
    }

    loadDictionary(data) {
        this.setState({
            dictionary: data
        });

        window.dictionary = data;
    }

    toggleDictionary() {
        this.props.onToggle();
    }

    getIdByAnchor(id) {
        return this.state.dictionary.findIndex(el => el.id === id);
    }

    scrollToElement(id) {
        let scrollY = document.querySelector(`[data-id="${id}"]`).offsetTop - 65;
        document.querySelector(".dictionary__menu").scrollBy(0, scrollY);
    }

    handleClick(e) {
        let id = e.target.dataset.id;
        this.updateId(id);
    }

    handleLink(e) {
        e.preventDefault();
        if (e.target.tagName === "A") {
            let dictId = e.target.href.split("/#")[1];
            let id = this.getIdByAnchor(dictId);
            this.updateId(id);
            this.scrollToElement(id);
        }
    }

    render() {
        const id = +this.state.currentId;
        let links = this.state.dictionary.map((el, i) =>
            <div key={i} data-id={i} className={"dictionary__item" + (id === i ? " current" : "")}>{el.title}</div>
        );

        let dict = this.state.dictionary;
        let content = dict && dict[id] ? (`<h2>${dict[id].title}</h2>` + dict[id].text) : "";
        content = {__html: content};

        return <div className="dictionary container__shadow" style={{zIndex: 11}}>
            <div className="dictionary__content container__content">
                <GameWindowHeader title="СПРАВОЧНИК" isClosable={true} onHide={this.toggleDictionary.bind(this)}
                                  width={1300} height={40}/>
                <div className="dictionary__body">
                    <div className="dictionary__menu" onClick={this.handleClick.bind(this)}>{links}</div>
                    <div className="dictionary__current" dangerouslySetInnerHTML={content} onClick={this.handleLink.bind(this)}/>
                </div>
            </div>
        </div>;
    }
}
